module.exports = __webpack_public_path__ + "img/icon-1.839f4a96.svg";